import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isCartOpen: false,
  isAddtoCartOpen: false,
  cart: [],
  selectedCategory: null, // ✅ single object only
  items: [],
  contactInfo: [],
  note: "", // ✅ ADD THIS
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    /* ================= SET ITEMS ================= */
    setItems: (state, action) => {
      state.items = action.payload;
    },

    /* ================= ADD CATEGORY TO CART ================= */
    addCategoryToCart: (state, action) => {
      state.selectedCategory = action.payload; // ✅ overwrite always
    },

    /* ================= ADD TO CART ================= */
    addToCart: (state, action) => {
      const newItem = action.payload.item;

      // 🔥 IMPORTANT: item + selectedOption = unique cart item
      const existingItem = state.cart.find(
        (item) =>
          item._id === newItem._id &&
          item.selectedOption === newItem.selectedOption,
      );

      if (existingItem) {
        existingItem.count += newItem.count || 1;
      } else {
        state.cart.push({
          ...newItem,
          count: newItem.count || 1,
        });
      }
    },

    /* ================= REMOVE FROM CART ================= */
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter(
        (item) =>
          !(
            item._id === action.payload._id &&
            item.selectedOption === action.payload.selectedOption
          ),
      );
    },

    /* ================= INCREASE COUNT ================= */
    increaseCount: (state, action) => {
      state.cart = state.cart.map((item) => {
        if (
          item._id === action.payload._id &&
          item.selectedOption === action.payload.selectedOption
        ) {
          item.count++;
        }
        return item;
      });
    },

    /* ================= DECREASE COUNT ================= */
    decreaseCount: (state, action) => {
      state.cart = state.cart.map((item) => {
        if (
          item._id === action.payload._id &&
          item.selectedOption === action.payload.selectedOption &&
          item.count > 1
        ) {
          item.count--;
        }
        return item;
      });
    },

    /* ================= TOGGLE CART ================= */
    setIsCartOpen: (state) => {
      state.isCartOpen = !state.isCartOpen;
    },

    /* ================= CONTACT INFO ================= */
    setContactInfo: (state, action) => {
      state.contactInfo = action.payload;
    },
    /* ================= set Note ================= */

    setNote: (state, action) => {
      state.note = action.payload;
    },

    clearNote: (state) => {
      state.note = "";
    },
    /* ================= set Note ================= */

    setTip: (state, action) => {
      state.tip = action.payload;
    },

    clearTip: (state) => {
      state.tip = 0;
    },

    /* ================= EMPTY CART ================= */
    emptyCart: (state) => {
      state.cart = [];
      state.note = ""; // ✅ FIXED
      state.tip = 0; // ✅ correct
    },
  },
});

export const {
  setItems,
  addToCart,
  removeFromCart,
  increaseCount,
  decreaseCount,
  setIsCartOpen,
  setContactInfo,
  emptyCart,
  //add category to cart
  addCategoryToCart,
  setNote, // ✅ add thi
  clearNote,
  setTip,
  clearTip,
} = cartSlice.actions;

export default cartSlice.reducer;
